<template>
  <div class="vehicle-search pa-10">

    <title-page icon="mdi-car">
      {{ $t('menu.vehicles') }}
    </title-page>

    <v-row class="mt-5">
      <v-col>
        <vehicle-list exportable />
      </v-col>
    </v-row>

  </div>
</template>

<script>
import VehicleList from "@/components/elements/VehicleList.vue";

export default {
  components: { VehicleList },

  created() {
    // Global vehicle directory is reserved to EaseZE operators.
    if (!this.currentUser.isZE) {
      this.$router.replace({ name: 'dashboard' })
    }
  },
}
</script>

<style lang="scss">
</style>
